export default __webpack_public_path__ + "static/integrations_ga-ceb489480d82989e569c24c17ed4febd.png";